import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {isInStock} from "../../lookFunctions2";

const LookFeatureNotInStock = (props) => {

  const {lookFeature} = props;

  if (isInStock(lookFeature)) {
    return null
  }

  return (
    <span className="lm-stock lm-stock--red">
      <FormattedMessage id="look.feature.outOfStock"/>
    </span>
  )
};

LookFeatureNotInStock.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeatureStockCount} = store.lookState;
  return {
    lookActiveFeatureStockCount,
  };
};

export default connect(mapStateToProps)(LookFeatureNotInStock)
